<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="d_flex_btwn">
          <h5 class="common_subtitle pb_20  font_16p pt_20">Users </h5>
        </div>

        <div class="d_flex_start pt_10 pb_10">
            <button v-if="can('user_create')" type="button" class="btn btn-outline-primary btn-sm mr_15 width_100p" @click="openModal()">
              Create User
            </button>
            <button v-if="can('user_edit')" type="button" class="btn btn-outline-primary btn-sm mr_15 width_100p"
                    @click.prevent="openModal(selectedRecord.id)"
                    :disabled="!selectedRecord || !selectedRecord.id"
            >
              Edit
            </button>
            <button v-if="can('user_delete')" type="button" class="btn btn-outline-danger btn-sm mr_15 width_100p"
                    @click.prevent="deleteRecord()"
                    :disabled="!selectedRecord || !selectedRecord.id">
              Delete
            </button>
            <button type="button" class="btn btn-outline-info btn-sm mr_15 width_260p"
                    @click.prevent="viewRootServiceNumber()"
            >
              View Root Account Service Number
            </button>
          <button type="button" class="btn btn-outline-primary btn-sm width_100p"
                  @click.prevent="loadData()"
          >
            Refresh
          </button>
        </div>

        <cloud-table-component
            :columns="columns"
            :rows="inquiries"
            :sortable="sortable"
            :pagination="pagination"
            @sorting="sorting"
            @pageChanged="pageChanged">
          <template v-slot:id="{ row }">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" :id="'action_'+row.id" @focus="checkSingleData(row, $event)" :checked="selectedRecord?.id === row.id">
              <label class="form-check-label" :for="'action_'+row.id"></label>
            </div>
          </template>

          <template v-slot:policy="{ row }">
            {{ formattedText(row.policy) }}
          </template>
          <template v-slot:policyGroup="{ row }">
            {{ formattedText(row.policyGroup) }}
          </template>
        </cloud-table-component>
      </div>
    </div>

    <BaseModal
        v-if="isShowInquiryModal"
        :title="modalTitle"
        :closeModal="closeModal"
        size="modal_850p"
    >
      <UserForm
          :closeModal="closeModal"
          :loadData="loadData"
          :editId="editId"
      />
    </BaseModal>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CloudTableComponent from "@/components/shared/CloudTableComponent.vue";
import UserForm from "@/views/iam/UserForm.vue";
import BaseModal from "@/components/BaseModal.vue";
import { useAbility } from '@casl/vue';

export default {
  name: "User",
  components: {BaseModal, UserForm, CloudTableComponent},
  data() {
    return {
      inquiries: [],
      filter: {
      },
      queryParams: {
        page: 1,
        search: '',
        search_columns: 'user_id,email,phone,policy.name,policyGroup.name',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 10
      },
      sortable: {
        order: 'created_at',
        sort: 'desc'
      },
      columns: [
        {
          label: "",
          field: "id",
          sortable: false,
          slot: true,
        },
        {
          label: "User Id",
          field: "root_user_id",
          sortable: true,
        },
        {
          label: "E-mail",
          field: "email",
          sortable: true,
        },
        {
          label: "Mobile Phone",
          field: "phone",
          sortable: true,
        },
        {
          label: "Policy",
          field: "policy",
          slot: true,
        },
        {
          label: "Policy Group",
          field: "policyGroup",
          slot: true,
        },
      ],
      pagination: null,
      isShowInquiryModal: false,
      editId: null,
      selectedRecord: null
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === from.name && !window._.isEqual(to, from)) {
        this.setQueryData(this.getAllQueryParams())
        this.loadData()
      }
    },
  },
  computed: {
    modalTitle(){
      if (this.editId) {
        return 'Edit User';
      } else {
        return 'Add New User';
      }
    },
    ...mapGetters({
        customer: 'auth/getUser'
    })
  },
  mounted() {
    const query = this.getAllQueryParams()
    if (query.page) {
      this.setQueryData(query)
    }
    this.loadData()
  },
  methods: {
    setQueryData(query) {
      this.queryParams = {
        page: query.page,
        search: query.search,
        search_columns: query.search_columns,
        sort: query.sort,
        sort_order: query.sort_order,
        per_page: query.per_page
      }

      this.filter = {

      }

      this.sortable = {
        order: query.sort,
        sort: query.sort_order
      }
    },
    resetAll() {
      this.sortable = {
        order: 'created_at',
        sort: 'desc'
      }

      this.filter = {
      }

      this.queryParams = {
        page: 1,
        search: '',
        search_columns: 'user_id,email,phone,policy.name,policyGroup.name',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 10
      }

      this.changeRoute();
      this.loadData();
    },
    searchQuery() {
      this.changeRoute();
    },
    sorting({column, order}) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
      this.queryParams.page = 1;
      this.changeRoute()
    },
    pageChanged(page) {
      this.queryParams.page = page;
      this.changeRoute()
    },
    changeRoute() {
      this.$router.push({name: this.$route.name, query: {...this.queryParams, ...this.filter}})
    },
    loadData() {
      this.lyLoading = true
      this.axios.get('/customers', {
        params: { ...this.queryParams, ...this.filter }
      })
          .then(({data}) => {
            this.inquiries = data.data
            this.pagination = data.meta;
          })
          .finally(() => {
            this.lyLoading = false;
          })
    },
    openModal(editId = null){
      this.editId = editId
      this.isShowInquiryModal = true;
    },
    closeModal(){
      this.isShowInquiryModal = false;
    },
    checkSingleData(user, event){
      event.target.blur();
      if (this.selectedRecord?.id === user.id) {
        this.selectedRecord = null;
      } else {
        this.selectedRecord = user;
      }
    },
    deleteRecord() {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/customers/'+this.selectedRecord.id)
              .then((response) => {
                if(response.data.success){
                  this.selectedRecord = null;
                  this.showSuccessMsg(response.data.message);
                  this.loadData();
                }else{
                  this.showFailMsg(response.data.message)
                }
              });
        }
      });
    },
    viewRootServiceNumber(){
      this.$swal({
        title: "Root Account Service Number",
        text: this.customer?.service_number,
        // icon: "info"
      });
    },
    formattedText(texts) {
      if (texts?.length) {
        return texts.map((item) => item.name).join(', ')
      }
    }
  },
  setup() {
    const { can } = useAbility();

    return {
      can
    };
  }
}
</script>

<style scoped>

</style>